var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dh-player"},[_c('div',{ref:"DHVideoIntercomPlayer",staticClass:"dh-player-main-box DHVideoPlayer DHvideoPlayerIntercom",attrs:{"id":"DHVideoPlayer"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2b5fe7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DHPlayer/DHPlayer.vue
// module id = null
// module chunks = 